import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import classes from './Signup.module.css';
import axios from 'axios'; // automaticaly stringify js object -->json with fetch we need to JSON.stringify(js oj in body) when post data
import DefaultHeader from '../main/Layout/DefaultHeader';
import Navbar1 from '../main/Layout/Navbar1';

const Signup =()=> {
	const [values,setValues] = useState({
		name:"",
		email:"",
		password:"",
		confirmPassword:"",
		error:"",
		success:false
	});

	const {name,email,password,confirmPassword,error,success} = values;

	const handleChange = name =>event=>{
		setValues({...values,error:false,[name]:event.target.value});//[name]-->create obj {name:"panh",emai:"...",...}
	};

	const handleSignInClickFb = () => {
        // Authenticate using via passport api in the backend
        // Open facebook login page
        // window.open("http://localhost:8000/api/auth/facebook", "_self")
        window.open("https://nhathuocvantien.herokuapp.com/api/auth/facebook", "_self")
      };
      const handleSignInClickGg = () => {
        // Authenticate using via passport api in the backend
        // Open facebook login page
        // window.open("http://localhost:8000/api/auth/google", "_self");//_self not move to another tap
        window.open("https://nhathuocvantien.herokuapp.com/api/auth/google", "_self");//_self not move to another tap
      };

	const clickSubmit =(event)=>{
		event.preventDefault();
		setValues({...values,error:false});
		const body ={
				name:name,
				email:email,
				password:password,
				confirmPassword:confirmPassword//just for user experience not save in db,
			//this will save to server
		}
		axios.post('/signup',body)
		.then(data=>{
			setValues({...values,name:"",email:"",password:"",error:"",confirmPassword:"",success:true,})//graps inital values and update to empty to clear input
		}).catch(err=>{
			setValues({...values,error:err.response.data.message,success:false})
		})

	}


	const showError=()=>(
	<div className="alert alert-danger" style={{display:error?"":"none"}}>{error}</div>
	)
	const showSuccess=()=>(
		<div className="alert alert-success" style={{display:success?"":"none"}}>
			Tạo thành công tài khoản, vui lòng <Link to="/signin">Đăng nhập</Link>
		</div>
	)


    const signUpForm = ()=>(
<React.Fragment>
	<h4 className="card-title mt-3 text-center">Create Account</h4>
	<p className="text-center">Get started with your free account</p>
	<p>
	<button onClick ={handleSignInClickGg}  className = "btn btn-block btn-danger" > <i className="fab fa-google"></i>   Login via Google</button>
    <button onClick ={handleSignInClickFb} className={`btn btn-block ${classes.btnfacebook}`}> <i className="fab fa-facebook-f"></i>   Login via facebook</button>
	</p>
	<p className={classes.dividertext}>
        <span className="bg-light">OR</span>
    </p>
	<form>
	<div className="form-group input-group">
		<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-user"></i> </span>
		 </div>
		 {/* set value={name}-->user experience */}
        <input onChange={handleChange('name')} value={name} className="form-control" placeholder="Full name" type="text"/>
    </div> 
    <div className="form-group input-group">
    	<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-envelope"></i> </span>
		 </div>
        <input onChange={handleChange('email')} value={email} className="form-control" placeholder="Email address" type="email"/>
    </div> 
    <div className="form-group input-group">
    	<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-phone"></i> </span>
		</div>
		<select className="custom-select" style={{"maxWidth": "120px"}}>
		    <option value="">+84</option>
		</select>
    	<input className="form-control" placeholder="Phone number" type="text"/>
    </div> 
    <div className="form-group input-group">
    	<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-building"></i> </span>
		</div>
		<select className="form-control">
			<option > Select job type</option>
			<option>Designer</option>
			<option>Manager</option>
			<option>Accaunting</option>
		</select>
	</div>
    <div className="form-group input-group">
    	<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-lock"></i> </span>
		</div>
        <input onChange={handleChange('password')} value={password}  className="form-control" placeholder="Create password" type="password"/>
    </div> 
    <div className="form-group input-group">
    	<div className="input-group-prepend">
		    <span className="input-group-text"> <i className="fa fa-lock"></i> </span>
		</div>
        <input onChange={handleChange('confirmPassword')} value={confirmPassword} className="form-control" placeholder="Repeat password" type="password"/>
    </div>                                     
    <div className="form-group">
        <button onClick={clickSubmit} className="btn btn-primary btn-block"> Create Account  </button>
    </div>   
    <p className="text-center">Have an account? <Link to="/signin">Log In</Link> </p>                                                                 
</form>
 </React.Fragment>
    )
    return (
		<React.Fragment>
			<Navbar1/>
			<DefaultHeader/>
        
			<div className="container-fluid" >
				<br/>  
				<div className="row justify-content-md-center ">
    				<div className="col col-lg-6 col-md-6 col-xs-6">
				
						<div className={`${classes.Card} card`} >
						<div className="card-body mx-auto col col-lg-9 " style={{"width":"500px"}}>
							{showError()}
							{showSuccess()}
							{signUpForm()}
							</div>
						</div>
					</div>
				</div>
				<br/>  
			</div>
		</React.Fragment>
       
        
    );
}

export default Signup;